import optionField from "./optionField.component";

const optionFieldModule = angular
  .module("app.components.optionField", [])
  .component("optionField", optionField);

export default optionFieldModule;



// WEBPACK FOOTER //
// ./src/components/optionField/optionField.module.js